<template>
  <div>
    <el-card>
      <el-select
        class="m-w"
        v-model="PostListValue"
        filterable
        placeholder="请选择岗位"
      >
        <el-option
          v-for="item in PostList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-w"
        v-model="StatusListValue"
        placeholder="请选择评价状态"
      >
        <el-option
          v-for="item in StatusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="PostName"
        placeholder="请输入学生名称"
      ></el-input>

      <el-button type="primary" @click="GetEP_PracticeInfoByPage"
        >查询</el-button
      >

      <el-button @click="clecrData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="StudentName"
          label="学生姓名"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="StudyYearName" label="学届" align="center">
        </el-table-column>
        <el-table-column prop="GradeName" label="年级" align="center">
        </el-table-column>
        <el-table-column prop="ClassName" label="班级" align="center">
        </el-table-column>
        <el-table-column prop="PostType" label="岗位类型" align="center">
        </el-table-column>
        <el-table-column prop="PostName" label="岗位名称" align="center">
        </el-table-column>
        <el-table-column prop="MaskName" label="共建单位名称" align="center">
        </el-table-column>
        <el-table-column prop="Address" label="地址" align="center">
        </el-table-column>
        <el-table-column label="实践内容" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Content"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Content }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="getImg(scope.row.Image)[0]"
              :preview-src-list="getImg(scope.row.Image)"
              fit="contain"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="StatusName" label="审核状态" align="center">
        </el-table-column>
        <el-table-column prop="EvalStatusName" label="评价状态" align="center">
        </el-table-column>
        <el-table-column
          prop="EvalLevelEnumName"
          label="评价级别"
          align="center"
        >
        </el-table-column>
        <el-table-column label="评价内容" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.HomeEval"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.HomeEval }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="Time" label="时长(分钟)" align="center">
        </el-table-column>
        <el-table-column prop="UpdateTime" label="更新时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="onClickEvaluate(scope.row)"
              v-if="scope.row.EvalStatus == 1"
              >去评价</el-button
            >
            <el-button type="text" v-if="scope.row.EvalStatus == 2" disabled
              >已评价</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      title="去评价"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="评价级别" prop="evalLevelEnum">
            <el-radio-group v-model="ruleForm.evalLevelEnum">
              <el-radio :label="1">优秀</el-radio>
              <el-radio :label="2">良好</el-radio>
              <el-radio :label="3">合格</el-radio>
              <el-radio :label="4">不合格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="评价内容" prop="evalDetail">
            <el-input type="textarea" v-model="ruleForm.evalDetail"></el-input>
          </el-form-item>
          <el-form-item label="分数" prop="Score">
            <el-input
              type="number"
              :max="100"
              :min="0"
              v-model="ruleForm.Score"
              placeholder="1"
            ></el-input>
          </el-form-item>
          <el-form-item label="时长（分钟）" prop="Time">
            <el-input
              type="number"
              placeholder="分钟"
              v-model="ruleForm.Time"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="Eval_ForPracticeInfo('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Get_PostSelectInfo,
  GetEP_PracticeInfoByPage,
  Eval_ForPracticeInfo,
} from "../../api/api";
export default {
  data() {
    return {
      PostList: [],
      PostListValue: "",
      StatusList: [
        {
          Id: "0",
          Name: "全部",
        },
        {
          Id: "1",
          Name: "待评价",
        },
        {
          Id: "2",
          Name: "已评价",
        },
      ],
      StatusListValue: "0",
      PostName: "",
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      ruleForm: {
        id: 0,
        evalDetail: "",
        evalLevelEnum: 1,
        Time: "",
        Score: null,
      },
      rules: {
        evalDetail: [
          { required: true, message: "请填写评价内容", trigger: "blur" },
        ],
        evalLevelEnum: [
          { required: true, message: "请填写评价级别", trigger: "change" },
        ],
        Time: [{ required: true, message: "请输入时长", trigger: "blur" }],
        Score: [{ required: true, message: "请输入分数", trigger: "blur" }],
      },
      loading: false,
    };
  },
  created() {
    this.Get_PostSelectInfo();
    this.GetEP_PracticeInfoByPage();
  },
  methods: {
    Eval_ForPracticeInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await Eval_ForPracticeInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });

            this.loading = false;
            this.$refs[formName].clearValidate();
            this.handleClose();
            this.GetEP_PracticeInfoByPage();
          } else {
            this.loading = false;

            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clecrData() {
      this.PostListValue = "";
      this.PostName = "";
      this.StatusListValue = "0";
      this.GetEP_PracticeInfoByPage();
    },
    async onClickEvaluate(item) {
      this.ruleForm.id = item.Id;
      this.dialogVisible = true;
    },
    handleClose() {
      this.ruleForm = {
        evalDetail: "",
        Time: "",
        evalLevelEnum: 1,
        Score: null,
      };
      this.dialogVisible = false;
    },
    getImg(val) {
      if (val) {
        return val.split(",");
      }
    },
    async GetEP_PracticeInfoByPage() {
      let res = await GetEP_PracticeInfoByPage({
        EP_PostId: this.PostListValue == "" ? 0 : this.PostListValue,
        StudentName: this.PostName,
        EvalStatus: this.StatusListValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
        FBStatus: 1,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetEP_PracticeInfoByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetEP_PracticeInfoByPage();
    },
    async Get_PostSelectInfo() {
      let res = await Get_PostSelectInfo({
        Id: 0,
      });
      if (res.data.success) {
        this.PostList = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}
.tui-detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>